export default function EditTrainingPresentationDirectiveController(
  $q,
  $scope
) {
  const vm = this;
  const trainingAdminPresentationNameLength = 255;
  const trainingAdminPresentationThumbnailNameLength = 255; // eslint-disable-line no-unused-vars

  vm.handlePresentationFileAdd = _handlePresentationFileAdd;
  vm.handlePresentationFileValidate = _handlePresentationFileValidate;

  function _handlePresentationFileAdd() {
    vm.newMediaInputs.presentationFile.progress = 0;
  }

  function _handlePresentationFileValidate($file) {
    let isValid = true;
    if ($file.name.indexOf('&') > -1) {
      $scope.editMediaPresentationForm.presentationFile.$setValidity('specialCharacters', false);
      isValid = false;
    } else {
      $scope.editMediaPresentationForm.presentationFile.$setValidity('specialCharacters', true);
    }
    if ($file.name.length > trainingAdminPresentationNameLength) {
      $scope.editMediaPresentationForm.presentationFile.$setValidity('nameLength', false);
      isValid = false;
    } else {
      $scope.editMediaPresentationForm.presentationFile.$setValidity('nameLength', true);
    }
    return isValid;
  }
}

EditTrainingPresentationDirectiveController.$inject = [
  '$q',
  '$scope'
];
